import Seo from "../components/Seo";
import { SectionHead, PrimaryLink, CTABand, PlaceholderNote } from "../components/bits";
import { PLATFORM } from "../content/pages";

export default function Platform() {
  return (
    <>
      <Seo
        path="/goandtrack-platform"
        title="GoAndTrack Platform"
        description="GoAndTrack is the tracking platform both the GNTS1 Bluetooth sticker and LL100 4G label report into — maps, geofences, history, exports and roles."
      />
      <section className="border-b border-border bg-brand-surface">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <p className="font-mono text-xs font-medium uppercase tracking-widest text-primary">The platform</p>
          <h1 className="mt-4 max-w-3xl text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">GoAndTrack</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">{PLATFORM.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8" data-testid="platform-capabilities">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {PLATFORM.capabilities.map((c) => (
            <article key={c.name} className="rounded-sm border border-border bg-white p-6" data-testid={`platform-cap-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <h2 className="text-lg font-semibold text-brand-navy">{c.name}</h2>
              <p className="mt-2 text-sm leading-relaxed text-brand-slate">{c.detail}</p>
            </article>
          ))}
          <div className="rounded-sm border border-dashed border-brand-slate/40 bg-brand-surface p-6">
            <h2 className="text-lg font-semibold text-brand-navy">Screenshots &amp; live demo</h2>
            <p className="mt-2 text-sm leading-relaxed text-brand-slate">
              [Approved GoAndTrack screenshots pending. A guided demo of the platform is part of every pilot scoping call — ask on the form.]
            </p>
          </div>
        </div>
        <div className="mt-10 max-w-3xl space-y-4">
          <PlaceholderNote text={PLATFORM.caveat} />
        </div>
        <div className="mt-10"><PrimaryLink to="/request-a-pilot" testid="platform-cta">Ask for a platform demo</PrimaryLink></div>
      </section>

      <CTABand />
    </>
  );
}
